export interface FinancialFigure {
  name: string;
  current: number | string | null;
  previous: number | string | null;
  change: number | null;
  direction: 'up' | 'down' | 'flat' | null;
  type: string;
}

export function financialSections(accounts: Record<string, any> | null | undefined): Array<{ name: string; columns: string[]; rows: FinancialFigure[] }> {
  return Object.entries(accounts || {}).map(([name, section]) => {
    const columns = (section?.columns || []).map((column: any) => column.column_name);
    const rows = (section?.rows || []).map((row: any) => {
      const current = row.data?.[columns[0]] ?? null;
      const previous = row.data?.[columns[1]] ?? null;
      const a = typeof current === 'number' ? current : Number(current);
      const b = typeof previous === 'number' ? previous : Number(previous);
      const numeric = current !== null && previous !== null && Number.isFinite(a) && Number.isFinite(b);
      const direction = !numeric ? null : a > b ? 'up' : a < b ? 'down' : 'flat';
      // A near-zero denominator can create a dramatic but unhelpful percentage.
      const percentage = numeric && b !== 0 ? Math.abs((a - b) / b * 100) : numeric && a === 0 && b === 0 ? 0 : null;
      return { name: row.name, current, previous, change: percentage !== null && percentage <= 999 ? percentage : null, direction, type: row.type || 'number' };
    });
    return { name, columns, rows };
  });
}

export function financialRow(sections: ReturnType<typeof financialSections>, name: string): FinancialFigure | null {
  return sections.flatMap(section => section.rows).find(row => row.name.toLowerCase() === name.toLowerCase() && row.current !== null) || null;
}
